import { render, staticRenderFns } from "./BlogPreview.vue?vue&type=template&id=24e2c93e&"
import script from "./BlogPreview.vue?vue&type=script&lang=ts&"
export * from "./BlogPreview.vue?vue&type=script&lang=ts&"
import style0 from "./BlogPreview.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports